import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { logEvent } from '../utils/logEvent';
import { FaHeart } from 'react-icons/fa';

const Navigation = () => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      const currentUser = data?.session?.user || null;
      setUser(currentUser);
      setRole(currentUser?.app_metadata?.role || null);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      const currentUser = session?.user || null;
      setUser(currentUser);
      setRole(currentUser?.app_metadata?.role || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setRole(null);
    navigate('/login');
  };

  const handleNav = async (e, route, eventType, details) => {
    e.preventDefault();
    await logEvent(eventType, details);
    navigate(route);
  };

  return (
    <nav className="bg-white shadow px-6 py-4 flex justify-between items-center">
      <Link to="/" className="flex items-center gap-2">
        <img src="/empowerher_nav_logo.png" alt="EmpowerHer Logo" className="h-[110px]" />
      </Link>

      <div className="space-x-6 text-[1.1rem] font-medium">
        <Link to="#" onClick={(e) => handleNav(e, '/', 'click_nav_home', { nav_target: 'home' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">Home</Link>
        <Link to="#" onClick={(e) => handleNav(e, '/about', 'click_nav_about', { nav_target: 'about' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">About</Link>
        <Link to="#" onClick={(e) => handleNav(e, '/courses', 'click_nav_courses', { nav_target: 'courses' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">Courses</Link>
        <Link to="#" onClick={(e) => handleNav(e, '/dashboard', 'click_nav_dashboard', { nav_target: 'dashboard' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">Dashboard</Link>
        <Link to="#" onClick={(e) => handleNav(e, '/faqs', 'click_nav_faqs', { nav_target: 'faqs' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">FAQs</Link>
        {role === 'admin' && (
          <Link to="#" onClick={(e) => handleNav(e, '/admin', 'click_nav_admin', { nav_target: 'admin' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">Admin</Link>
        )}
        <Link to="#" onClick={(e) => handleNav(e, '/contact', 'click_nav_contact', { nav_target: 'contact' })} className="text-xl font-medium text-gray-800 hover:text-blue-600">Contact</Link>
        <Link
          to="#"
          onClick={(e) => handleNav(e, '/donate', 'click_nav_donate', { nav_target: 'donate' })}
          className="inline-flex items-center gap-2 bg-indigo-600 text-white px-3 py-1.5 rounded-md text-sm font-semibold hover:bg-indigo-700 transition duration-300 animate-glow"
        >
          <FaHeart className="text-pink-300 animate-pulse" />
          Donate
        </Link>

        {!user ? (
          <Link to="/login" className="text-xl font-medium text-gray-800 hover:text-blue-600">Login</Link>
        ) : (
          <>
            <span className="text-xl font-medium text-gray-800 hover:text-blue-600">{user.email}</span>
            <button
              onClick={handleLogout}
              className="text-red-600 hover:text-red-800 font-semibold"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
